export class AdvisoryLead {

	public FirstName: string;
	public LastName: string;
	public CompanyName: string;
	public Email: string;
	public Title: string;
	public Phone: string;
	public WebPage: string;
	public Comments: string;
	public Street: string;
	public City: string;
	public State: string;
	public Zipcode: string;
	public Country: string;
}



// WEBPACK FOOTER //
// ./src/app/models/AdvisoryLead.ts